<ng-container *ngIf="booking">
    <div class="partfixa header header-card" [ngClass]="{'expanded':expanded}">
        <div class="leftData">
            <div class="line bookingNumber">{{ booking.bookingNumber }}
                <div class="chevron clickable">
                    <i class="fa fa-chevron-circle-right" aria-hidden="true" (click)="toggleView()"></i>
                </div>
            </div>
            <div class="line shipName">{{ booking.shipName }}
                <div class="deposit no-expanded" [@fadeInOut]><span class="prompt">{{ 'BOOKINGPAGE.DEPOSIT.LABEL'
                        | translate
                        }}</span> {{
                    booking.depositStart |
                    datahoradetalldiasetmana
                    }} -
                    {{ booking.depositEnd | datahoradetalldiasetmana }}</div>
            </div>
            <shared-tags-strip-component *ngIf="expanded" [@fadeInOut] class="line tagsbottom tags no-margin-between"
                [tags]="booking.userTags">
            </shared-tags-strip-component>
            <div class="line dates" *ngIf="expanded" [@fadeInOut]>
                <div class="line"><span class="prompt">{{ 'BOOKINGPAGE.DEPOSIT.LABEL' | translate }}</span> {{
                    booking.depositStart |
                    datahoradetalldiasetmana
                    }} -
                    {{ booking.depositEnd | datahoradetalldiasetmana }}</div>
                <div class="line"><span class="prompt">{{ 'BOOKINGPAGE.TRIP.LABEL' | translate }}</span> {{
                    booking.datetimeStart |
                    datahoradetalldiasetmana }}
                    -
                    {{ booking.datetimeEnd | datahoradetalldiasetmana }}</div>
            </div>
        </div>
    </div>
    <shared-booking-strip [booking]="booking"></shared-booking-strip>
</ng-container>
<div class="only-show-empty" *ngIf="!booking">
    <div class="line center">{{ 'BOOKINGPAGE.NOBOOKING' | translate }}</div>
</div>